"use client";

import MessageContext from '@/context/MessageProvider';
import { Button, SxProps, Theme, Typography } from "@mui/material";
import { Share } from "@mui/icons-material";
import { Koleksi } from "@/types/shared.types";
import { useContext } from 'react';


type Props = {
  koleksi: Koleksi
  sx?: SxProps<Theme> | null;
}

export default function ShareKoleksiButton({koleksi, sx}: Props) {
  const { message, setMessage } = useContext(MessageContext)!;

  return <Button
    fullWidth
    size="large"
    variant="contained"
    startIcon={<Share />}
    onClick={() => {
      if (!navigator.share) {
        setMessage({ isOpen: true, content: 'Fitur berbagi tidak didukung di browser ini. URL telah disalin ke clipboard.' });
        navigator.clipboard.writeText(document.location.href);
        return;
      }
      navigator.share({
        title: koleksi.judul,
        text: `Lihat koleksi ${koleksi.judul} di Perpustakaan STIS`,
        url: document.location.href
      })
    }}
    sx={{
      ...sx,
    }}
  >
    <Typography sx={{
      marginLeft: 'auto',
      marginRight: 'auto'
    }}>
      Bagikan
    </Typography>
  </Button>
}